import {Fragment, React } from '@api'
import {TopBarComponent} from '@design-board/components'
import { CatalogStore } from '@stores';

import {runInAction} from 'mobx';

interface MyComponentProps {

}

interface MyProps extends MyComponentProps {
  catalog: CatalogStore
}

export class TopBar extends React.Component<MyProps> {
  file: HTMLInputElement = null

  onClickMassCreateWithImage = () => {
    this.file.value = null
    this.file.click()
  }

  onSelectImages = (event: React.ChangeEvent<HTMLInputElement>) => {
    const target = event.target
    const {
      props: {catalog: {
          massCreate, refetch, sidebar
        }}
    } = this
    if (target.files.length > 0) {
      massCreate.createProductWithImages(target.files).then((res: any) => {
        massCreate.productCount = 1
        runInAction(() => {
          sidebar.right.action = 'create'
          refetch()
        })
      })
    }
  }

  render () {
    const {onClickMassCreateWithImage, props: {catalog} } = this

    return (
      <Fragment>
        <TopBarComponent
          onClickMassCreateWithImage={onClickMassCreateWithImage}
        />
        <input
          type="file"
          ref={el => (this.file = el)}
          style={{display: 'none'}}
          multiple
          onChange={this.onSelectImages}
        />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/topBar/containers/TopBar.tsx